var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "certi-page" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 10, offset: 2 } }, [
            _c(
              "div",
              { staticStyle: { "text-align": "center", margin: "20px 0" } },
              [
                _vm._v(
                  "\n        证书编号：" + _vm._s(this.presId) + "\n      "
                )
              ]
            ),
            _c("div", { staticClass: "img-certi" }, [
              _vm.certStatus
                ? _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.certLoading,
                          expression: "certLoading"
                        }
                      ],
                      staticStyle: {
                        "min-height": "637px",
                        display: "inline-block",
                        width: "100%"
                      },
                      attrs: {
                        href: _vm.certUrl,
                        target: "_blank",
                        title: "点击放大"
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: _vm.certUrl },
                        on: {
                          loadstart: function($event) {
                            _vm.certLoading = true
                          },
                          load: function($event) {
                            _vm.certLoading = false
                          }
                        }
                      })
                    ]
                  )
                : _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.certLoading,
                          expression: "certLoading"
                        }
                      ],
                      staticStyle: {
                        "min-height": "637px",
                        display: "inline-block"
                      },
                      attrs: { href: "javascript:void(0);", title: "点击刷新" },
                      on: {
                        click: function($event) {
                          return _vm.flushCertStatus(_vm.$route.query)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: _vm.certUrl },
                        on: {
                          loadstart: function($event) {
                            _vm.certLoading = true
                          },
                          load: function($event) {
                            _vm.certLoading = false
                          }
                        }
                      })
                    ]
                  )
            ])
          ]),
          _c("el-col", { attrs: { span: 10, offset: 2 } }, [
            _c("div", { staticClass: "div-certification" }, [
              false
                ? _c("h6", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("\n          区块链存证查询\n          "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "rgba(0, 0, 0, 0.45)",
                          "font-size": "12px",
                          "font-weight": "500"
                        }
                      },
                      [_vm._v("/ 提示：请先复制证书编号，再进入查询")]
                    )
                  ])
                : _vm._e(),
              false
                ? _c(
                    "div",
                    { staticClass: "btn-box" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.toPath(
                                "http://iacg.aihuz.com/",
                                "_blank"
                              )
                            }
                          }
                        },
                        [_vm._v("赣国仲裁委")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.toPath(
                                "http://swzcw.aihuz.com/",
                                "_blank"
                              )
                            }
                          }
                        },
                        [_vm._v("深汕仲裁委")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.toPath(
                                "http://syac.aihuz.com/",
                                "_blank"
                              )
                            }
                          }
                        },
                        [_vm._v("十堰仲裁委")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          staticStyle: {
                            "margin-left": "0",
                            "margin-top": "20px"
                          },
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.toPath(
                                "http://cngzc.sfj.taiyuan.gov.cn/web/index.html#/chain",
                                "_blank"
                              )
                            }
                          }
                        },
                        [_vm._v("城南公证处")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c("h6", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("存证证书下载")
              ]),
              _c(
                "div",
                { staticClass: "btn-box" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.downloadCert(1)
                        }
                      }
                    },
                    [_vm._v("下载JPG证书")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.downloadCert(2)
                        }
                      }
                    },
                    [_vm._v("下载PDF证书")]
                  )
                ],
                1
              ),
              _c("h6", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("法律服务申请")
              ]),
              _c(
                "div",
                { staticClass: "btn-box" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.redirectTesity("")
                        }
                      }
                    },
                    [_vm._v("申请出证")]
                  ),
                  false
                    ? _c("div", { staticClass: "dropdown" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("\n              在线申请仲裁"),
                          _c("i", {
                            staticClass: "el-icon-caret-bottom color-danger"
                          })
                        ]),
                        _c("ul", { staticClass: "dropdown-menu" }, [
                          _c(
                            "li",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.redirectTesity("arbitration")
                                }
                              }
                            },
                            [_vm._v("广州仲裁委")]
                          ),
                          _c("li", { on: { click: _vm.toZHArb } }, [
                            _vm._v("珠海仲裁委")
                          ])
                        ])
                      ])
                    : _vm._e()
                ],
                1
              ),
              false
                ? _c(
                    "div",
                    { staticClass: "btn-box" },
                    [
                      _vm.fqgzStatus.fqgzFlag
                        ? _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "small" },
                              on: {
                                click: function($event) {
                                  _vm.showFqgzDialog = true
                                }
                              }
                            },
                            [_vm._v("赋强公证")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.redirectTesity("sjw")
                            }
                          }
                        },
                        [_vm._v("申请债权变现")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showFqgzDialog,
            title: "赋强公证出证",
            width: "550px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showFqgzDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _vm.fqgzStatus.jkrFlag
                ? [
                    _c("h6", [_vm._v("法律服务")]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "10px",
                          "margin-bottom": "20px"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { size: "small", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.redirectTesity("fqgzs")
                              }
                            }
                          },
                          [_vm._v("公证书")]
                        ),
                        _vm.fqgzStatus.fqzxsFlag
                          ? _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: { type: "danger", size: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.redirectTesity("fqzxs")
                                  }
                                }
                              },
                              [_vm._v("执行书")]
                            )
                          : _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: { size: "small", disabled: "" }
                              },
                              [_vm._v("执行书")]
                            )
                      ],
                      1
                    ),
                    _c("h6", [_vm._v("温馨提示：")]),
                    _c(
                      "div",
                      {
                        staticClass: "margin-bottom-lg text-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      [
                        _vm._v(
                          "\n          办理赋强公证的流程是：签署时申请>获取受理函>申请公证书>申请执行证书，如果您需要申请执行证书的话，请务必先取得公证书，否则无法申请。\n        "
                        )
                      ]
                    )
                  ]
                : [
                    _c("h6", [_vm._v("特别提示：")]),
                    _c("div", { staticClass: "margin-bottom-lg text-left" }, [
                      _vm._v(
                        "\n          借出方已为该合同申请了赋强公证，公证处已受理。如逾期不还款，借出方有权直接向公证处申请强制执行书，并通过法院强制执行债务追回。为了您的良好征信记录，请积极履约，按时还款。\n        "
                      )
                    ])
                  ]
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { "text-align": "center", "margin-top": "40px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "120px" },
                  attrs: { size: "small", type: "danger" },
                  on: {
                    click: function($event) {
                      _vm.showFqgzDialog = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d26b907e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d26b907e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/certi/certiPage.vue
// module id = 8zRC
// module chunks = 249